export default __webpack_public_path__ + "static/media/minerva.9eedb274.png";